import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

export type HydraSendSurveyProps = {
  hydraToken: string
  optionId: string
  additionalText?: string | undefined
}
export const HydraPostSurveyResponse = ({
  optionId,
  additionalText,
  hydraToken,
}: HydraSendSurveyProps) => {
  const request: SendRequestType = {
    method: 'POST',
    url: '/surveys/responses',
    token: hydraToken,
    data: {
      responseOptions: [
        {
          optionId,
          ...(additionalText && { additionalText }), // Only required if user selects 'other' as the response
        },
      ],
    },
  }

  return httpTools.sendRequest(request)
}
